export const PoleFieldIds = {
	POLE_NUMBER: 'poleNumber',
	POLE_ID: 'poleID',
	IMAGES: 'images',
	POLE_TYPE: 'poleType',
	POLE_OWNER: 'poleOwner',
	CIRCUMFERENCE: 'circumference',
	NOTE: 'note',
	AGL: 'agl',
	GEOGRAPHIC_COORDINATE: 'geographicCoordinate',
	IKE_PHOTO: 'trueSizeCapture',
	STATUS: 'status',
	PLA_RESULT: 'plaResult',
	SPAN: {
		FORM: 'span',
		TYPE: 'spanType',
		LENGTH: 'spanLength',
		ENVIRONMENT: 'spanEnvironment',
		MID_SPAN_PHOTO: 'spanMidSpanPhoto',
		NOTE: 'spanNote',

		// Fields added as part of Base Form
		WIRE: {
			FORM: 'spanWire',
			MID_SPAN_HEIGHT: 'spanWireMidSpanHeight',
			USAGE_GROUP: 'spanWireUsageGroup',
			OWNER: 'spanWireOwner',
			ATTACHMENT_HEIGHT: 'spanWireAttachmentHeight',
		},
	},
	CIRCUIT: {
		FORM: 'circuit',
		CONSTRUCTION: 'circuitConstruction',
		MID_SPAN_HEIGHT: 'circuitMidSpanHeight',
	},
	WIRE: {
		FORM: 'wire',
		OWNER: 'wireOwner',
		INSULATOR: 'wireInsulator',
		ATTACHMENT_HEIGHT: 'wireAttachmentHeight',
		SIZE: 'wireSize',
		QUANTITY: 'wireQuantity',
	},
	ANCHOR: {
		FORM: 'anchor',
		TYPE: 'anchorType',
		OWNER: 'anchorOwner',
		LENGTH: 'anchorLeadLength',
		NOTE: 'anchorNote',

		// Fields added as part of Base Form
		GUY: {
			FORM: 'anchorGuy',
			SIZE: 'anchorGuySize',
			OWNER: 'anchorGuyOwner',
			ATTACHMENT_HEIGHT: 'anchorGuyAttachmentHeight',
		},
	},
	GUY: {
		FORM: 'guys',
		SIZE: 'guySize',
		OWNER: 'guyOwner',
		ATTACHMENT_HEIGHT: 'guyAttachmentHeight',
	},
	EQUIPMENT: {
		FORM: 'equipment',
		TYPE: 'equipmentType',
		ATTACHMENT_HEIGHT: 'equipmentAttachmentHeight',
		ATTACHMENT_BOTTOM_HEIGHT: 'equipmentBottomHeight',
		ORIENTATION: 'equipmentOrientation',
		QUANTITY: 'equipmentQuantity',
		OWNER: 'equipmentOwner',
		NOTE: 'equipmentNote',
	},
	SPAN_GUY: {
		FORM: 'spanGuys',
		SIZE: 'spanGuySize',
		OWNER: 'spanGuyOwner',
		ATTACHMENT_HEIGHT: 'spanGuyAttachmentHeight',
		MID_SPAN_HEIGHT: 'spanGuyMidSpanHeight',
		HEIGHT_AT_WEP: 'spanGuyHeightAtWEP',
		TYPE: 'spanGuyType',
	},

	// Fields added as part of Base Form
	SEQUENCE: 'sequence',
	LOW_POWER_ATTACHMENT: 'lowPowerAttachment',
	LOW_POWER_TO_COMM: 'lowPowerToComm',
	STREET_ADDRESS: 'streetAddress',

	MAKE_READY: {
		FORM: 'makeReady',
		ATTACHMENT_SIZE: 'makeReadyAttachmentSize',
		ATTACHMENT_TYPE: 'makeReadyAttachmentType',
		ATTACHMENT_HEIGHT: 'makeReadyAttachmentHeight',
		PROPOSED_MID_SPAN: 'makeReadyProposedMidSpan',
		PROPOSED_RISER: 'makeReadyProposedRiser',
		TYPE: 'makeReadyType',
		NOTE: 'makeReadyNote',
	},
} as const;

const PoleFieldName = {
	[PoleFieldIds.POLE_NUMBER]: 'Pole Number',
	[PoleFieldIds.POLE_ID]: 'Id',
	[PoleFieldIds.IMAGES]: 'Tag Photos',
	[PoleFieldIds.POLE_TYPE]: 'Type',
	[PoleFieldIds.POLE_OWNER]: 'Owner',
	[PoleFieldIds.CIRCUMFERENCE]: 'Circumference (")',
	[PoleFieldIds.NOTE]: 'Note',
	[PoleFieldIds.PLA_RESULT]: 'PLA Result',
	[PoleFieldIds.AGL]: 'Tip',
	[PoleFieldIds.GEOGRAPHIC_COORDINATE]: 'Location',
	[PoleFieldIds.IKE_PHOTO]: 'IKE Photo',
	[PoleFieldIds.STATUS]: 'Status',
	[PoleFieldIds.SPAN.FORM]: 'Span',
	[PoleFieldIds.SPAN.TYPE]: 'Type',
	[PoleFieldIds.SPAN.LENGTH]: 'Span Length',
	[PoleFieldIds.SPAN.ENVIRONMENT]: 'Environment',
	[PoleFieldIds.SPAN.MID_SPAN_PHOTO]: 'Mid Span IKE Photo',
	[PoleFieldIds.SPAN.NOTE]: 'Note',
	[PoleFieldIds.CIRCUIT.FORM]: 'Circuit',
	[PoleFieldIds.CIRCUIT.CONSTRUCTION]: 'Construction',
	[PoleFieldIds.CIRCUIT.MID_SPAN_HEIGHT]: 'Mid Span Height',
	[PoleFieldIds.WIRE.FORM]: 'Wire',
	[PoleFieldIds.WIRE.OWNER]: 'Owner',
	[PoleFieldIds.WIRE.INSULATOR]: 'Insulator',
	[PoleFieldIds.WIRE.ATTACHMENT_HEIGHT]: 'Attachment Height',
	[PoleFieldIds.WIRE.SIZE]: 'Size',
	[PoleFieldIds.WIRE.QUANTITY]: 'Quantity',
	[PoleFieldIds.ANCHOR.FORM]: 'Anchor',
	[PoleFieldIds.ANCHOR.TYPE]: 'Type',
	[PoleFieldIds.ANCHOR.OWNER]: 'Owner',
	[PoleFieldIds.ANCHOR.LENGTH]: 'Lead Length',
	[PoleFieldIds.ANCHOR.NOTE]: 'Note',
	[PoleFieldIds.GUY.FORM]: 'Guys',
	[PoleFieldIds.GUY.SIZE]: 'Size',
	[PoleFieldIds.GUY.OWNER]: 'Owner',
	[PoleFieldIds.GUY.ATTACHMENT_HEIGHT]: 'Attachment Height',
	[PoleFieldIds.EQUIPMENT.FORM]: 'Equipment',
	[PoleFieldIds.EQUIPMENT.TYPE]: 'Type',
	[PoleFieldIds.EQUIPMENT.ATTACHMENT_HEIGHT]: 'Attachment Height',
	[PoleFieldIds.EQUIPMENT.ATTACHMENT_BOTTOM_HEIGHT]: 'Bottom Height',
	[PoleFieldIds.EQUIPMENT.ORIENTATION]: 'Orientation',
	[PoleFieldIds.EQUIPMENT.QUANTITY]: 'Quantity',
	[PoleFieldIds.EQUIPMENT.OWNER]: 'Owner',
	[PoleFieldIds.EQUIPMENT.NOTE]: 'Note',
	[PoleFieldIds.SPAN_GUY.FORM]: 'Span Guy',
	[PoleFieldIds.SPAN_GUY.SIZE]: 'Size',
	[PoleFieldIds.SPAN_GUY.OWNER]: 'Owner',
	[PoleFieldIds.SPAN_GUY.ATTACHMENT_HEIGHT]: 'Attachment Height',
	[PoleFieldIds.SPAN_GUY.MID_SPAN_HEIGHT]: 'Mid Span Height',
	[PoleFieldIds.SPAN_GUY.HEIGHT_AT_WEP]: 'Height at WEP',
	[PoleFieldIds.SPAN_GUY.TYPE]: 'Type',
};

export function displayName(poleFieldId: string) {
	const display = PoleFieldName[poleFieldId as keyof typeof PoleFieldName];
	if (display == null) {
		throw new Error(`Display name not found for: '${poleFieldId}'`);
	}

	return display;
}
